// src/pages/brand-collaborations-client-stories/components/CollaborationHero.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const CollaborationHero = () => {
  const heroMetrics = [
    { number: '150+', label: 'Brand Partnerships', icon: 'Handshake' },
    { number: '85%', label: 'Repeat Collaborations', icon: 'Repeat' },
    { number: '50+', label: 'Fortune 500 Clients', icon: 'Award' },
    { number: '5+', label: 'Years Average Partnership', icon: 'Clock' }
  ];

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-background-dark">
      {/* Background */}
      <div className="absolute inset-0 z-0">
        <Image
          src="https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg?auto=compress&cs=tinysrgb&w=2000"
          alt="Corporate collaboration meeting"
          className="w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-dark/95 via-background-dark/80 to-background-dark/95" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-5xl mx-auto">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 bg-accent/20 backdrop-blur-sm border border-accent/30 rounded-full px-6 py-2 mb-8">
            <Icon name="Users" size={16} color="#D4AF37" strokeWidth={2} />
            <span className="text-accent font-medium text-sm">Strategic Brand Partnerships</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl md:text-7xl font-bold text-text-primary-inverse mb-6 leading-tight">
            Brand
            <span className="text-gradient-gold block">Collaborations</span>
            <span className="text-3xl md:text-4xl font-normal text-text-secondary-inverse block mt-4">
              Client Stories
            </span>
          </h1>

          {/* Subheading */}
          <p className="text-xl md:text-2xl text-text-secondary-inverse mb-8 leading-relaxed max-w-4xl mx-auto">
            Discover the evolution of strategic partnerships through narrative journeys that showcase trust, 
            consistency, and measurable business impact across Fortune 500 corporations and luxury brands
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6 mb-16">
            <Link
              to="/booking-concierge-premium-consultation"
              className="bg-accent hover:bg-accent-dark text-white px-8 py-4 rounded-lg font-semibold text-lg cinematic-transition cta-glow hover:shadow-elevation"
            >
              Begin Your Partnership
            </Link>
            <Link
              to="/cinematic-showcase-portfolio"
              className="border-2 border-text-secondary-inverse text-text-primary-inverse hover:bg-white/10 px-8 py-4 rounded-lg font-semibold text-lg cinematic-transition backdrop-blur-sm"
            >
              View Success Stories
            </Link>
          </div>

          {/* Metrics */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {heroMetrics.map((metric, index) => (
              <div key={index} className="text-center">
                <div className="w-12 h-12 bg-accent/20 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto mb-3">
                  <Icon name={metric.icon} size={24} color="#D4AF37" strokeWidth={2} />
                </div>
                <div className="text-3xl font-bold text-text-primary-inverse mb-1">{metric.number}</div>
                <div className="text-text-secondary-inverse text-sm">{metric.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <Icon name="ChevronDown" size={24} color="#D4AF37" strokeWidth={2} />
      </div>
    </section>
  );
};

export default CollaborationHero;